import React from 'react';
import {
  Route,
  Switch,
  Redirect
} from 'react-router-dom';
import Slash from './containers/Slash';
import Traffic from './containers/Traffic';


let Routes = () => {

  return (
    <div>
      <Route exact path="/" component={Slash}/>
      <Switch>
        <Route path="/" component={Traffic}/>
        <Redirect to="/"/>
      </Switch>
    </div>
  );
};


export default Routes;


// WEBPACK FOOTER //
// ./src/routes.js